export default class SeoResource {
  public static toAltText(text: string): string {
    return (text ?? '').replace(/\s+/g, '_');
  }
}
